import { createSelector } from "reselect";

const mmRfqFormData = (state) => {
    return state?.mmRfqFormDataReducer?.mmRfqFormDataToStore;
};

export const mmRfqFormDataSelector = createSelector(
    mmRfqFormData,
    (mmRfqFormData) => mmRfqFormData
);
